import {PubBeer} from 'typescript/models/PubBeer';

interface IArgs {
  list: PubBeer[];
  startIndex: number;
  endIndex: number;
}

const reorder = ({list, startIndex, endIndex}: IArgs) => {
  const result = [...list];
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export default reorder;
